import { useNetInfo } from '@react-native-community/netinfo';
import { Box, ScrollView } from 'native-base';
import React, { ReactNode } from 'react';
import { Platform } from 'react-native';

import CPAlert from 'app/components/CPAlert';
import { useI18n } from 'app/providers/I18nProvider';
import { tID } from 'app/services/TestHelper';

export type OfflineProps = {
  children?: ReactNode;
};

export default function OfflineBanner({ children }: OfflineProps) {
  const { t } = useI18n();
  const { isInternetReachable } = useNetInfo();

  if (isInternetReachable !== false) return null;

  /**
   * On native devices, ScrollView wrapper and extra padding-bottom
   * is needed on so that text will expand its' height.
   * On web, Box wrapper and regular padding works.
   */
  const Wrapper = (Platform.OS === 'web' ? Box : ScrollView) as typeof Box;

  return (
    <Wrapper _web={{ pb: '2' }} borderWidth="1" p="2" pb="6" zIndex="1">
      <CPAlert
        status="error"
        testID={tID('OfflineBanner')}
        title={t<string>('app_error_no_connection')}
      />
    </Wrapper>
  );
}
